// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"7e466f4d","142":"ba5a9950","337":"12801cbc","342":"ba5a9950"}[chunkId] + ".chunk.css";
};